/**
 * Read `data` from a GraphQL response body.
 *
 * GraphQL can return data together with errors for individual items (e.g.
 * get_sites across several projects, where one site in another project is
 * missing a required field). With allowPartial, such a response still
 * yields its data and the item errors are returned for logging; without
 * it, or when there is no data at all, the first error is thrown.
 */
export function graphqlData(json, { allowPartial = false } = {}) {
  const errors = Array.isArray(json?.errors) ? json.errors : [];
  const data = json?.data ?? null;
  if (errors.length > 0 && (!allowPartial || data == null)) {
    throw new Error(errors[0]?.message || 'GraphQL query failed');
  }
  return { data, errors };
}
